import ArtistFilter from "components/filters/Filters/ArtistFilter";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import PeriodFilter from "components/filters/Filters/PeriodFilter";
import { ProductionSortFilter } from "components/filters/Filters/SortFilter";
import StatusFilter from "components/filters/Filters/StatusFilter";
import React from "react";

interface FiltersProps {
  initialStatuses: server.dto.StatusSmall[]
}

const Filters = (props: FiltersProps) => {
  return <>
    <KeywordFilter placeholder={RESX.GeneralLabels.Keyword} />
    <ArtistFilter />
    {props.initialStatuses.length > 1 && (
      <StatusFilter initialStatuses={props.initialStatuses} />
    )}
    <PeriodFilter />
    <ProductionSortFilter />
  </>;
};

export default Filters;